module.exports = __webpack_public_path__ + "static/media/background.4f7e5f65.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/cities/miami/background.jpg
// module id = 921
// module chunks = 27